import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import EditIcon from '@material-ui/icons/Edit'
import { Dialog } from '@material-ui/core'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../../config/settings'
import * as actions from '../actions/TablaVolcadorasConCerealAsignadoActions'
import DialogoVolcadoraUpdate from '../components/DialogoVolcadoraUpdate'
import { connect } from 'react-redux'

function OperacionesVolcadoras (props) {
  const { volcadora } = props

  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)

  const handleClose = () => {
    setOpen(false)
  }

  const handleSubmit = async () => {
    const {
      volcadora
    } = props

    props.modificarVolcadoraCamiones(volcadora)
    handleClose()
  }

  function onClick () {
    handleOpen()
  }
  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <>
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth='xs'>
          <DialogoVolcadoraUpdate volcadora={volcadora} handleClose={handleClose} handleSubmit={handleSubmit} />
        </Dialog>
        <>
          <Tooltip title={'Modificar Silo y Cereal'}>
            <IconButton onClick={onClick}>
              <EditIcon />
            </IconButton>
          </Tooltip>
        </>
      </>
    </>
  )
}

const withRedux = connect(null, actions)

export default withRedux(OperacionesVolcadoras)
